import {Component, TemplateRef, TrackByFunction, input, contentChild} from '@angular/core';
import {NgClass, NgTemplateOutlet} from '@angular/common';

export enum ListLayout {
  List = 'list',
  Compact = 'compact',
}

export interface ColumnConfig {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
}

@Component({
  selector: 'app-card-list',
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './card-list.component.html',
})
export class CardListComponent<T> {
  readonly items = input<T[]>([]);
  readonly testId = input('generic-card-list');
  readonly layout = input<ListLayout>(ListLayout.Compact);

  readonly columns = input<ColumnConfig>({
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
    xxl: 6,
  });

  readonly gap = input('gap-5');
  readonly cardWidth = input('minmax(16rem, 16rem)');
  readonly trackByFn = input<TrackByFunction<T>>((_, item) => item);

  readonly cardTemplate = contentChild.required<
    TemplateRef<{
      $implicit: T;
      index: number;
    }>
  >('cardTemplate');

  get layoutClasses(): string {
    switch (this.layout()) {
      case ListLayout.List:
        return `w-full flex flex-col ${this.gap()}`;
      case ListLayout.Compact: {
        const {sm = 2, md = 3, lg = 4, xl = 5, xxl = 6} = this.columns();
        return [
          'w-full',
          'grid',
          'grid-cols-1',
          `sm:grid-cols-${sm}`,
          `md:grid-cols-${md}`,
          `lg:grid-cols-${lg}`,
          `xl:grid-cols-${xl}`,
          `2xl:grid-cols-${xxl}`,
          this.gap(),
        ].join(' ');
      }
      default:
        return `w-full flex flex-col ${this.gap()}`;
    }
  }
}
